import React from "react";
import { NavLink } from "react-router-dom";

const Error = () => {
  return (
    <>
      <div className="flex-container">
        <div className="text-center">
          <h1>
            <span className="fade-in" id="digit1">
              4
            </span>
            <span className="fade-in" id="digit2">
              0
            </span>
            <span className="fade-in" id="digit3">
              4
            </span>
          </h1>
          <h3 className="fadeIn mb-5">PAGE NOT FOUND</h3>
          <NavLink to='/dashboard' className="home_button">
            Return To Home
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default Error;
